import React from 'react'
import { Alert, Button, Step, StepLabel, Stepper, Typography } from '@mui/material'
import IconTooltipButton from '../../../../../button/IconTooltipButton'
import { useDispatch, useSelector } from 'react-redux'
import {
  updateBulkMarkingData,
  updateErrorBulkMarking,
  updateStepBulkMarking
} from '../../../../../../store/actions/class-marking.actions'
import DialogConfirmCancel from '../../../../../dialog/DialogConfirm'
import UserChip from '../../../../../chip/UserChip'
import useMarking from '../../../../../../hooks/maestro/useMarking'
import { useParams } from 'react-router-dom'
import { handlerErrorV2 } from '../../../../../../utils/errors'
import ButtonStartIcon from '../../../../../button/ButtonStartIcon'

const StepsButtonBulkMarking = ({ loading }) => {
  const dispatch = useDispatch()
  const { ulId } = useParams()
  const currentCurriculum = useSelector((state) => state?.assessment?.currentCurriculum || {})
  const minMarking = currentCurriculum?.marking?.find((item) => item.minValue) || {}
  const step = useSelector((state) => state?.classMarking?.stepBulk || 0)
  const studentsSelected = useSelector((state) => state?.classMarking?.studentsBulk || [])
  const lcs = useSelector((state) => JSON.parse(JSON.stringify(state?.class?.unitOfLearning?.lcs || [])))
  const bulkMarking = useSelector((state) => ({
    lcs: state?.classMarking?.lcs || [],
    logMarking: state?.classMarking?.logMarking || []
  }))
  const error = useSelector((state) => state?.classMarking?.errorBulk || {})
  const steps = ['Select students', 'Marking']
  const [dialog, setDialog] = React.useState(false)
  const [loadingSave, setLoadingSave] = React.useState(false)

  const { updateStudentsBulkMarkingByClassIdAndUlId } = useMarking()

  const onStep = (step) => {
    dispatch(updateStepBulkMarking(step))
  }
  const onNext = (step) => {
    if (studentsSelected.length < 2) {
      dispatch(updateErrorBulkMarking({ message: 'Select at least two students' }))
    } else {
      dispatch(
        updateBulkMarkingData({
          lcs: lcs.map((lc) => ({
            ...lc,
            ulId: ulId,
            granularSteps: lc.granularSteps.map((gs) => ({
              ...gs,
              completedTeacher: minMarking._id
            }))
          })),
          logMarking: []
        })
      )
      onStep(step)
    }
  }

  const onSave = async () => {
    setLoadingSave(true)
    try {
      const response = await updateStudentsBulkMarkingByClassIdAndUlId(studentsSelected, bulkMarking)
      if (response.error) {
        dispatch(updateErrorBulkMarking({ message: response.message }))
      } else {
        dispatch(updateStepBulkMarking(0))
        setDialog(false)
      }
    } catch (error) {
      const message = handlerErrorV2(error)
      dispatch(updateErrorBulkMarking({ message }))
    } finally {
      setLoadingSave(false)
    }
  }

  return (
    <>
      <div className='flex items-center justify-center bg-background gap-2'>
        <div className='min-w-200px'>
          <Stepper color='primary' activeStep={parseInt(step)} className='w-full'>
            {steps.map((step, index) => (
              <Step key={`step-${index}`}>
                <StepLabel>{step}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </div>
        <div className='flex items-center justify-end gap-4'>
          <div className='min-w-25px'>
            {parseInt(step) > 0 && (
              <IconTooltipButton
                disabled={loading}
                title='Previous'
                icon='chevron-left'
                classNameIcon='text-lg'
                style={{
                  borderRadius: '0.5rem',
                  padding: '0.45rem',
                  color: 'var(--primary)',
                  backgroundColor: '#fff',
                  width: 25,
                  height: 25
                }}
                className='shadow-sm'
                onClick={() => onStep(parseInt(step) - 1)}
              />
            )}
          </div>
          <div className='min-w-25px'>
            {parseInt(step) === steps.length - 1 ? (
              <ButtonStartIcon
                disabled={loading}
                loading={loadingSave}
                startIcon={['fal', 'check']}
                onClick={() => setDialog(true)}
                className='shadow-sm font-bold'
              >
                Save
              </ButtonStartIcon>
            ) : (
              <IconTooltipButton
                disabled={loading}
                title='Next'
                icon='chevron-right'
                classNameIcon='text-lg'
                style={{
                  borderRadius: '0.5rem',
                  padding: '0.45rem',
                  color: 'var(--primary)',
                  backgroundColor: '#fff',
                  width: 25,
                  height: 25
                }}
                className='shadow-sm'
                onClick={() => onNext(parseInt(step) + 1)}
              />
            )}
          </div>
        </div>
      </div>
      <DialogConfirmCancel
        id='dialog-confirm-cancel-bulk-marking'
        open={dialog}
        onCancel={() => setDialog(false)}
        title='Confirm bulk marking'
        loading={loadingSave}
        onConfirm={onSave}
      >
        <Typography className='pb-2'>
          Are you sure you want to save the marking for all selected students?
        </Typography>
        <div className='grid grid-cols-3 gap-2'>
          {studentsSelected.map((student, index) => (
            <UserChip
              key={`dialog-confirm-cancel-bulk-marking-student-${index}`}
              name={student?.fullName}
              {...student}
            />
          ))}
        </div>
        {error?.message && (
          <Alert severity='error' className='mt-2'>
            {error?.message}
          </Alert>
        )}
      </DialogConfirmCancel>
    </>
  )
}

export default StepsButtonBulkMarking
